module.exports = __webpack_public_path__ + "img/Australia.495c2dcb.png";